import './LoginPage.scss'
import { useState } from 'react'
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom'
import { MdOutlineLogin } from 'react-icons/md'
import { Alert } from '../../ui/Alert'
import { Button } from '../../ui/Button'
import { Card } from '../../ui/Card'
import { appBasePath, safeNext } from '../basePath'
import { getMsal, loginRequest, toSessionAccount } from '../msal'
import { exchange } from '../oaseToken'
import { setAccount, setToken, useSession } from '../session'

/** Public /login: MSAL popup, then the Oase token exchange, then `next`. */
export function LoginPage() {
  const { token } = useSession()
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const [isPending, setIsPending] = useState(false)
  const [hasFailed, setHasFailed] = useState(false)
  const next = safeNext(params.get('next'))

  if (token && !isPending) return <Navigate to={next} replace />

  const signIn = async () => {
    setIsPending(true)
    setHasFailed(false)
    try {
      const msal = getMsal()
      const result = await msal.loginPopup(loginRequest)
      msal.setActiveAccount(result.account)
      setAccount(toSessionAccount(result.account))
      setToken(await exchange(result.accessToken))
      void navigate(next, { replace: true })
    } catch (error) {
      console.error(error)
      setHasFailed(true)
      setIsPending(false)
    }
  }

  return (
    <main className="login-page" aria-label="Sign in">
      <div className="login-page__panel">
        <Card as="div" className="login-page__card">
          <div className="login-page__body">
            <img
              className="login-page__logo"
              src={`${appBasePath()}images/oap-logo-transparent.png`}
              alt="Oase Admin Portal"
              width={180}
              height={61}
            />
            <Button
              variant="primary"
              shape="pill"
              isBlock
              icon={<MdOutlineLogin />}
              isLoading={isPending}
              onClick={() => {
                void signIn()
              }}
            >
              {isPending ? 'Signing in…' : 'Sign in'}
            </Button>
            {hasFailed && (
              <Alert tone="danger" isLive className="login-page__error">
                Authentication failed, please retry
              </Alert>
            )}
          </div>
        </Card>
      </div>
    </main>
  )
}
